// Drizzle schema for the admin-managed global floor picker config.
//
// Split out of `./schema.ts` to keep the primary tables file under
// the 500-line policy cap (lint:max-lines). Re-exported from
// `@citycare/shared` via index.ts so the canonical import path is
// unchanged for consumers.
//
// `floor_options` is the admin-curated menu of floor names that
// field-staff see in the New Room dialog. The per-building `floors`
// table in ./schema.ts is the storage spaces.floor_id points to;
// floor_options is just the catalog. When a field-staff user picks
// an option, the capture write path (POST /capture/floors/resolve)
// find-or-creates a per-building `floors` row by name and points the
// new space at it. Existing spaces are never touched, so renames and
// deletes of floor_options affect only future captures (preserving
// historical records exactly as they were captured).

import {
  index,
  integer,
  pgTable,
  uniqueIndex,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core'

import { contracts } from './schema'
import { createdAtColumn, updatedAtColumn } from './schema-shared'

export const floorOptions = pgTable(
  'floor_options',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    contractId: uuid('contract_id')
      .notNull()
      .references(() => contracts.id, { onDelete: 'restrict' }),
    name: varchar('name', { length: 100 }).notNull(),
    // Per-contract picker ordering. Set explicitly by the dedicated
    // PUT /admin/floor-options/reorder endpoint; auto-assigned to
    // (MAX + 1) on insert so newly-added options append to the end.
    // Mirrors the same pattern used by every other admin-managed
    // ordered table (bases, sites, asset_systems, etc.).
    displayOrder: integer('display_order').notNull().default(0),
    createdAt: createdAtColumn(),
    updatedAt: updatedAtColumn(),
  },
  (t) => ({
    uniqueContractName: uniqueIndex('floor_options_contract_id_name_unique').on(
      t.contractId,
      t.name,
    ),
    contractIdx: index('floor_options_contract_id_idx').on(t.contractId),
  }),
)
